module.exports = {"private":true,"main":"./notification.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/reducers/notification/package.json
// module id = 851
// module chunks = 0 1